import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Modal from 'react-modal'
import styled from 'styled-components/macro'
import { Map, Polygon, GoogleApiWrapper } from 'google-maps-react'
import { NUTS_LEVEL_COLOR_MAPPING, customMapStyles } from 'store/constants/constants'
import LoadingSpinner from 'components/ui/LoadingSpinner'
import breakpoints from 'assets/stylesheet'
import { getRegionsAsList } from 'store/actions/filters'
import PropTypes from 'prop-types'

const CloseIcon = styled.i`
  font-size: 20px;
  color: #585a5f;
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 10px;
  cursor: pointer;
`
const ModalTitle = styled.h3`
  margin-top: 0;
  font-size: 22px;
  text-transform: none;
  width: 100%;
`
const MapContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${props => (props.reduced ? '100%' : '94%')};
  margin-bottom: ${props => (props.reduced ? '15px' : '0')};
  ${props =>
    props.reduced
      ? `
  &:after {
    content: "";
    display: block;
    padding-bottom: 65%;
  }`
      : null}
`
const NutsLevelSelector = styled.ul`
  padding-left: 10px;
  list-style-type: none;
  position: absolute;
  left: 0;
  top: 60px;
`
const NutsLevel = styled.li`
  padding: 10px;
  margin: 12px 16px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 12px;
  color: #ffffff;
  position: relative;
  background-color: ${props => NUTS_LEVEL_COLOR_MAPPING[props.level]};
  border: ${props => (props.selected ? '3px solid #ffffff' : '2px solid #ffffff')};
  box-shadow: ${props => (props.selected ? '0 0 6px 0 #c1c1c1' : 'none')};
  left: ${props => (props.selected ? '10px' : '0')};
  &:hover {
    box-shadow: 0 0 6px 0 #9faee5;
  }
  @media (max-width: ${breakpoints.bpTabletPx}) {
    padding: 5px;
    font-size: 10px;
  }
  > div > div {
    color: white !important;
  }
  i.fa.times:before {
    color: white !important;
  }
`

const ModalFix = styled.div`
  position: realtive;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  display: ${props => (props.isOpen ? 'flex' : 'none')};
`
const modalStyles = {
  content: {
    borderRadius: '4px',
    boxShadow:
      '0 16px 24px 2px rgba(0,0,0,0.14), 0 6px 30px 5px rgba(0,0,0,0.12), 0 8px 10px 0 rgba(0,0,0,0.2)',
    left: window.innerWidth > 768 ? '450px' : '40px'
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.15)',
    zIndex: 100
  },
  closeButton: {}
}

Modal.setAppElement('#root')

const LoadingContainer = () => <div />

class NutsModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      nutsLevel: 0
    }

    this.selectNuts = this.selectNuts.bind(this)
  }

  componentDidMount() {
    const { disableNutsSelect } = this.props
    if (disableNutsSelect === true) {
      this.setState({
        nutsLevel: ''
      })
    }
  }

  selectNuts(props, marker, e) {
    const { getRegionsAsList: getRegionsAsListAction, setNutsFilter, selectedValues } = this.props
    const { nutsLevel } = this.state
    const lat = e.latLng.lat()
    const lng = e.latLng.lng()
    const params = {
      lat,
      lng,
      level: nutsLevel
    }
    let selectedValuesArray = [...selectedValues]
    getRegionsAsListAction(params).then(response => {
      if (response.value.length > 0) {
        let newSelected = []
        response.value.forEach(obj => {
          newSelected = this.toggleInArray(selectedValuesArray, obj)
        })
        setNutsFilter(newSelected)
        this.forceUpdate()
      }
    })
  }

  // Adds to array if the variable is not found,
  // else removes from the array
  toggleInArray(array, variable) {
    const nut = {
      id: variable.nuts_id,
      label: variable.english_alias
        ? `[${variable.nuts_id}] ${variable.english_alias} / ${variable.name}`
        : `[${variable.nuts_id}] ${variable.name}`,
      paths: variable.paths,
      type: variable.type
    }
    if (array.length === 0) return [nut]
    const found = array.filter(element => element.id === variable.nuts_id)
    if (found.length === 0) {
      array.push(nut)
      return array
    }
    return array.filter(element => element.id !== variable.nuts_id)
  }

  handlePaths(paths) {
    const ps = []
    const checkPath = p => {
      p.forEach(current => {
        if (Array.isArray(current) && typeof current[0].lat) {
          ps.push(current)
        } else {
          current.forEach(p2 => checkPath(p2))
        }
      })
    }
    paths.forEach(p => checkPath(p))
    return ps
  }

  handleNutsLevelClick(nutsLevel) {
    this.setState({
      nutsLevel
    })
  }

  render() {
    const {
      toggleModal,
      sidebarReduced,
      modalOpen,
      google,
      selectedValues,
      filters: { isFilteredRegionsPending },
      disableNutsSelect
    } = this.props
    const { nutsLevel } = this.state
    const polygons = selectedValues.map(nut => {
      if (nut.paths) {
        return (
          <Polygon
            key={nut.id}
            paths={this.handlePaths(nut.paths)}
            strokeColor={NUTS_LEVEL_COLOR_MAPPING[nut.type]}
            strokeOpacity={0.8}
            strokeWeight={2}
            fillColor={NUTS_LEVEL_COLOR_MAPPING[nut.type]}
            fillOpacity={0.35}
            onClick={!disableNutsSelect ? this.selectNuts : ''}
          />
        )
      }
      return null
    })
    if (sidebarReduced) {
      return (
        <ModalFix
          isOpen={modalOpen}
          onRequestClose={toggleModal}
          contentLabel="NUTS selector Modal"
          className="map-container-landing"
          reduced={sidebarReduced}
        >
          <ModalTitle>Select nuts</ModalTitle>
          <MapContainer reduced={sidebarReduced}>
            <Map
              initialCenter={{
                lat: 52.519325,
                lng: 13.392709
              }}
              className="map"
              google={google}
              mapTypeControl={false}
              streetViewControl={false}
              fullscreenControl={false}
              styles={customMapStyles}
              style={{ position: 'relative', height: '100%', width: '100%' }}
              zoom={4}
              onClick={!disableNutsSelect ? this.selectNuts : ''}
            >
              {polygons}
              {isFilteredRegionsPending && <LoadingSpinner />}
            </Map>
          </MapContainer>
          <NutsLevelSelector>
            <NutsLevel
              selected={nutsLevel === 0}
              level={0}
              onClick={!disableNutsSelect ? () => this.handleNutsLevelClick(0) : ''}
            >
              NUTS0
            </NutsLevel>
            <NutsLevel
              selected={nutsLevel === 1}
              level={1}
              onClick={!disableNutsSelect ? () => this.handleNutsLevelClick(1) : ''}
            >
              NUTS1
            </NutsLevel>
            <NutsLevel
              selected={nutsLevel === 2}
              level={2}
              onClick={!disableNutsSelect ? () => this.handleNutsLevelClick(2) : ''}
            >
              NUTS2
            </NutsLevel>
            <NutsLevel
              selected={nutsLevel === 3}
              level={3}
              onClick={!disableNutsSelect ? () => this.handleNutsLevelClick(3) : ''}
            >
              NUTS3
            </NutsLevel>
          </NutsLevelSelector>
        </ModalFix>
      )
    }
    return (
      <Modal
        isOpen={modalOpen}
        onRequestClose={toggleModal}
        style={modalStyles}
        contentLabel="NUTS selector Modal"
      >
        <ModalTitle>Select nuts</ModalTitle>
        <MapContainer>
          <Map
            initialCenter={{
              lat: 52.519325,
              lng: 13.392709
            }}
            className="map"
            google={google}
            mapTypeControl={false}
            streetViewControl={false}
            fullscreenControl={false}
            styles={customMapStyles}
            style={{ position: 'relative', height: '100%', width: '100%' }}
            zoom={4}
            onClick={!disableNutsSelect ? this.selectNuts : ''}
          >
            {polygons}
            {isFilteredRegionsPending && <LoadingSpinner />}
          </Map>
        </MapContainer>
        <NutsLevelSelector>
          <NutsLevel
            selected={nutsLevel === 0}
            level={0}
            onClick={!disableNutsSelect ? () => this.handleNutsLevelClick(0) : ''}
          >
            NUTS0
          </NutsLevel>
          <NutsLevel
            selected={nutsLevel === 1}
            level={1}
            onClick={!disableNutsSelect ? () => this.handleNutsLevelClick(1) : ''}
          >
            NUTS1
          </NutsLevel>
          <NutsLevel
            selected={nutsLevel === 2}
            level={2}
            onClick={!disableNutsSelect ? () => this.handleNutsLevelClick(2) : ''}
          >
            NUTS2
          </NutsLevel>
          <NutsLevel
            selected={nutsLevel === 3}
            level={3}
            onClick={!disableNutsSelect ? () => this.handleNutsLevelClick(3) : ''}
          >
            NUTS3
          </NutsLevel>
        </NutsLevelSelector>
        <CloseIcon onClick={toggleModal} className="far fa-times" />
      </Modal>
    )
  }
}

NutsModal.propTypes = {
  modalOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
  getRegionsAsList: PropTypes.func,
  google: PropTypes.object,
  selectedValues: PropTypes.array,
  setNutsFilter: PropTypes.func,
  sidebarReduced: PropTypes.bool,
  defaultClosed: PropTypes.bool,
  closeModal: PropTypes.bool,
  filters: PropTypes.shape({
    isFilteredRegionsPending: PropTypes.bool
  }),
  disableNutsSelect: PropTypes.bool
}

const mapStateToProps = ({ filters }) => ({
  filters
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getRegionsAsList
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  GoogleApiWrapper({
    apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    LoadingContainer,
    libraries: ['places', 'visualization']
  })(NutsModal)
)
